
import { ReducerAction } from '../ReducerAction';
import { ActionType } from '../ActionsTypes';
import { getHistoricUseCase, getBalanceUseCase } from '../../../di/usecase_module';
import { GetHistoricRequestDto } from '../../../domain/usecases/sell/GetHistoricUseCase';
import { Sell } from '../../../domain/models/Sell';
import { Balance } from '../../../domain/models/Balance';
import { GetBalanceRequestDto } from '../../../domain/usecases/balance/GetBalanceUseCase';
import { handleError } from '../../utils/handleError';

export class BalanceActions {

    static setBalance(balance: Balance): ReducerAction {
        return {
            type: ActionType.BALANCE_UPDATE,
            payload: balance
        }
    }

    static setHistoric(sells: Sell[]): ReducerAction {
        return {
            type: ActionType.BALANCE_UPDATE_HISTORIC,
            payload: sells
        }
    }

    static updateBalance(token: string) {
        return (dispatch: any) => {
            getBalanceUseCase()
                .execute(new GetBalanceRequestDto(token))
                .then((result: Balance) => {
                    dispatch(BalanceActions.setBalance(result));
                    dispatch(BalanceActions.updateHistoric(token));
                }).catch((e) => {
                    handleError(e);
                });
        }
    }

    static updateHistoric = (token: string) => {
        return (dispatch: any) => {
            getHistoricUseCase()
                .execute(
                    new GetHistoricRequestDto(token)
                ).then((result) => {
                    dispatch(BalanceActions.setHistoric(result));
                }).catch((error) => {
                    handleError(error);
                });
        }
    }
}